import { each, get, isEmpty } from 'underscore';

export const extractExclusionRules = (finalUrlExpansions) => {
  const urlEquals = [];
  const urlContains = [];
  const customLabels = [];
  each(finalUrlExpansions, (target) => {
    const conditions = get(target, ['Criterion', 'WebPage', 'Parameter', 'Conditions'], []);
    if (isEmpty(conditions)) return;
    if (conditions[0].Operand === 'Url' && conditions[0].Operator === 'Equals') {
      urlEquals.push(conditions[0].ArgumentOperand);
    } else if (conditions[0].Operand === 'Url' && conditions[0].Operator === 'Contains') {
      const rules = [];
      each(conditions, (condition) => {
        rules.push(condition.ArgumentOperand);
      });
      urlContains.push(rules);
    } else if (conditions[0].Operand === 'CustomLabel') {
      customLabels.push(conditions[0].ArgumentOperand);
    }
  });
  return [urlEquals, urlContains, customLabels];
};

export const withHttpsPrefix = (url) => {
  if (!url) return '';
  else if (url.startsWith('http://') || url.startsWith('https://')) return url;
  return `https://${url}`;
};

export const keywordsToCriterionName = (keywords) => {
  const target = [];
  keywords.forEach((keyword) => {
    target.push(`Url contains ${keyword}`);
  });
  return target.join(' and ');
};

export const convertURLEqualsToCriterion = url => ({
  Criterion: {
    WebPage: {
      Type: 'Webpage',
      Parameter: {
        Conditions: [
          {
            Operand: 'Url',
            Operator: 'Equals',
            ArgumentOperand: url,
          },
        ],
        CriterionName: `Url=${url}`,
      },
    },
  },
});

export const convertURLContainsToCriterion = keyword => ({
  Criterion: {
    WebPage: {
      Type: 'Webpage',
      Parameter: {
        Conditions: [
          {
            Operand: 'Url',
            Operator: 'Contains',
            ArgumentOperand: keyword,
          },
        ],
        CriterionName: `Url contains ${keyword}`,
      },
    },
  },
});

export const convertCustomLabelToCriterion = label => ({
  Criterion: {
    Type: 'Webpage',
    WebPage: {
      Parameter: {
        Conditions: [
          {
            Operand: 'CustomLabel',
            Operator: 'Equals',
            ArgumentOperand: label,
          },
        ],
        CriterionName: `CustomLabel=${label}`,
      },
    },
  },
});
